<template>
  <v-container grid-list-xs style="max-width: 1070px" class="mt-4">
    <div v-show="avisosRegistros = true">
      <v-carousel cycle height="auto" class="mb-5" hide-delimiter-background show-arrows-on-hover> 
        <v-carousel-item v-for="(item, i) in itemsAvisos" :key="i" >
          <v-sheet height="100%" color="#1c3d6c" class="mb-5">
            <v-row class="fill-height" align="center" justify="center">
              <div class="white--text ma-10">
                <p class="text-h5 text-center">{{item.asunto}}</p>
                <p class="text-center">{{item.mensaje}}</p>
              </div>
            </v-row>
          </v-sheet>
          <!-- <v-card height="100%" flat class="px-10" color="#1c3d6c">
            <v-row >
              <v-card-text class="white--text text-center text-h5 mt-5">{{item.asunto}}</v-card-text>
              <v-card-text class="white--text text-center" >{{item.mensaje}}</v-card-text>
            </v-row>
          </v-card> -->
        </v-carousel-item>
      </v-carousel>
    </div>

    <div class="mt-5">
      <v-row align="center" justify="center">
        <v-alert v-if="periodoAbierto == false" type="error">¡INSCRIPCIONES CERRADAS!</v-alert>
        <v-alert v-if="ultimoDia == true" type="warning">¡ÚLTIMO DÍA DE INSCRIPCIONES!</v-alert>
        <div v-if="periodoAbierto == true && ultimoDia == false">
          <v-alert outlined color="success" class="text-center" width="320">
            <div class="text-h6">
              Tiempo Restante para el Cierre de Inscripiones:
            </div>
            <div>
              <Countdown :end="finInscripciones"></Countdown>
              <!-- <vue-countdown-timer :start-time="'2018-10-10 00:00:00'" :end-time="finInscripciones" :interval="1000" label-position="begin" :day-txt="'Dias'" :hour-txt="'Horas'" :minutes-txt="'Minutos'" :seconds-txt="'Segundos'"></vue-countdown-timer> -->
              <!-- Dias: <b>{{diasRestantes}}</b><br>
              Horas: <b>{{horasRestantes}}</b><br>
              Minutos: <b>{{minutosRestantes}}</b><br>
              Segundos: <b>{{segundosRestantes}}</b> -->
            </div>
          </v-alert>
        </div>
      </v-row>
    </div>

    <div class="mt-5">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-img :src="logoRuta" contain height="200"></v-img>
        </v-col>
      </v-row>
    </div>
    
    <div class="mt-7">
      <v-row align="center" justify="center" >
        <v-col cols="12" class="text-justify">
          <h3> <p> Como parte del programa de la Olimpiada Nacional de Química (ONQ), se celebra el concurso
          regional conocido como Olimpiada de Química CDMX. El concurso está dirigido a estudiantes de
          los niveles medio y medio superior inscritos en planteles ubicados en la Zona Metropolitana del 
          Valle de México. </p></h3>

          <h3><p>Los objetivos son diversos, pero primordialmente se pueden mencionar los siguientes: </p></h3>

          <h3><p>- Contribuir a un mejor conocimiento de los grandes beneficios que la química ha aportado &nbsp; a la 
            humanidad. <br>
          - Fomentar el interés por la química de un mayor número de jóvenes, para así estimular su &nbsp; &nbsp; curiosidad 
            científica y captarlos como futuros profesionales. <br>
          - Favorecer el intercambio de experiencias docentes entre profesores de nivel medio superior.<br>
          - Fortalecer el enlace entre el nivel medio y superior.</p></h3>

          <h3><p>El concurso consta de dos etapas, una clasificatoria y otra de entrenamiento, donde se busca tener un
          grupo homogéneo de estudiantes, hacerlos competitivos y que tengan una participación destacada en la Olimpiada Nacional de Química. </p></h3>
        </v-col>
      </v-row>
    </div>

  </v-container>  
</template>

<script>
import axios from 'axios';
import { createForm } from '../general'
import { mapGetters } from 'vuex'
import { documentosBaseURL }  from '../general';
import Countdown from '@/components/Countdown.vue'



export default {
  metaInfo: {
    title: 'Olimpiada de Quimica',
    titleTemplate: 'Inicio - %s',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },
  components: { Countdown },
  data(){
    return{
      itemsAvisos:[],
      logoRuta: '',
      periodoAbierto: null,
      ultimoDia: null,
      finInscripciones: '',
      avisosRegistros: false
    }
  },
  created(){
    this.getFechas()
    this.getAvisos()
    this.getLogo()
  },
  methods:{
    async getAvisos(){
      let response = await this.avisos();
      delete response['state'];
      if(Object.keys(response).length > 0 ){
        this.avisosRegistros = true
        Object.entries(response).forEach(([key, value]) => {
          this.itemsAvisos.push(value);
        });
      }else{
        this.avisosRegistros = false
      }
    },
      
    avisos(){
      return new Promise((resolve, reject) => {
        axios.post('avisos.php')
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },

    async getLogo(){
      let response = await this.logo();
      if(response.state == '1'){
        this.logoRuta = documentosBaseURL + response.ruta
      } // que hacer en caso de otros estados?
    },
      
    logo(){
      return new Promise((resolve, reject) => {
        axios.post('getLogo.php')
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },

    async getFechas(){
      let response = await this.fechas()
      this.finInscripciones =  response[1].fecha
      const fechaInicioInscripcion = response[0].fecha
      const fechaFinInscripcion = response[1].fecha
      const today = new Date().toISOString().slice(0,10)
      if(today >= fechaInicioInscripcion && today < fechaFinInscripcion){
        this.periodoAbierto = true
        this.ultimoDia = false
        // setInterval(this.contador, 1000);
      }else if (today == fechaFinInscripcion){
        this.ultimoDia = true
        this.periodoAbierto = true
      }else{
        this.periodoAbierto = false
      }
    },

    fechas(){
      return new Promise((resolve, reject) => {
        axios.post('fechas.php')
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },

    contador(){
      var tiempoRestante = ((this.finIns - new Date())/1000) + 21600;

      if(tiempoRestante > 0){ //Aún hay tiempo
        //Calculamos segundos, minutos y horas
        this.segundosRestantes = ('0'+Math.floor(tiempoRestante % 60)).slice(-2);
        this.minutosRestantes = ('0'+Math.floor(tiempoRestante/60 % 60)).slice(-2);
        this.horasRestantes = ('0'+Math.floor(tiempoRestante/3600 % 24)).slice(-2);
        this.diasRestantes = ('0'+Math.floor(tiempoRestante/(3600 * 24)));
      }
    }
    
  }
}
</script>

<style>
/* .vuejs-countdown .text {
  display: none;
} */
</style>